// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"X4-z"};